import axios from "@/common/axios";
import qs from "qs";

export function deleteVisitRegistration(id) {
  return axios({
    method: "delete",
    url: "/visitRegistration/delete/" + id,
  });
}

export function updateVisitRegistration(data) {
  return axios({
    method: "put",
    url: "/visitRegistration/update",
    data: qs.stringify(data),
  });
}

export function selectInfo(id) {
  return axios({
    method: "get",
    url: "/visitRegistration/selectInfo/" + id,
  });
}

export function selectByDateList(query) {
  return axios({
    method: "get",
    url: "/visitRegistration/selectByDateList",
    params: query,
  });
}

export function selectByCondition(query) {
  return axios({
    method: "get",
    url: "/visitRegistration/selectByCondition",
    params: query,
  });
}

export function byExport(query) {
  return axios({
    method: "get",
    url: "/visitRegistration/byExport",
    responseType: "blob",
    params: query,
  });
}

export function visitRegistrationOutput(query) {
  return axios({
    method: "get",
    url: "/visitRegistration/output",
    responseType: "blob",
    params: query,
  });
}

export function selectWebCountRegister(query) {
  return axios({
    method: "get",
    url: "/visitRegistration/selectWebCountRegister",
    params: query,
  });
}

export function addVisitLimit(data) {
  return axios({
    method: "post",
    url: "/visitRegistration/addVisitLimit",
    data: qs.stringify(data),
  });
}

export function updateStatus(data) {
  return axios({
    method: "put",
    url: "/visitRegistration/updateStatus",
    data: qs.stringify(data),
  });
}

export function updateStatusRegistration(id) {
  return axios({
    method: "put",
    url: "/visitRegistration/updateStatusRegistration/" + id,
  });
}

export function deleteByLimitId(id) {
  return axios({
    method: "put",
    url: "/visitRegistration/deleteByLimitId/" + id,
  });
}

export function updateByLimitStatus() {
  return axios({
    method: "get",
    url: "/visitRegistration/updateByLimitStatus",
  });
}

export function updateStatusById(data) {
  return axios({
    method: "put",
    url: "/visitRegistration/updateStatusById",
    data: qs.stringify(data),
  });
}

export function selectByLimitId(limitId) {
  return axios({
    method: "get",
    url: "/visitRegistration/selectByLimitId/" + limitId,
  });
}

export function addVisitTime(data) {
  return axios({
    method: "post",
    url: "/visitTime/addVisitTime",
    data: qs.stringify(data),
  });
}

export function batchAddVisitTime() {
  return axios({
    method: "get",
    url: "/visitTime/batchAddVisitTime",
  });
}

export function deleteByLimitIds(limitId) {
  return axios({
    method: "delete",
    url: "/visitTime/deleteByLimitIds/" + limitId,
  });
}

export function selectRegisterList(query) {
  return axios({
    method: "get",
    url: "/register/list",
    params: query,
  });
}

export function deleteRegister(id) {
  return axios({
    method: "delete",
    url: "/register/delete/" + id,
  });
}

export function registerReview(data) {
  return axios({
    method: "post",
    url: "/register/review",
    data: qs.stringify(data),
  });
}
